import { visitListRequest } from '@/common/queries/selections/visitList';
import { useQuery } from '@tanstack/react-query';

export const useVisitList = () => {
  const visitListQuery = useQuery({
    queryKey: ['visitList'],
    queryFn: () => visitListRequest(),
    select: (data) => {
      return data.map((item) => ({
        label: item.name?.fa_const,
        value: item.name?.const,
      }));
    },
  });
  return { visitListQuery };
};
